export const MEDIA_MAX_UPLOAD_SIZE = 1000 * 1000 * 1000;
export const EXCEL_MAX_UPLOAD_SIZE = 20 * 1000 * 1000;
